<template>
	<b-row class="view">
		<b-col
		cols="12"
		md="6">
			<h1>POLÍTICA DE PRIVACIDAD</h1>
			<h4>
				POLÍTICA DE PRIVACIDAD ARGENTINA
			</h4>
			<p>
				Al utilizar Pinocho libreria y jugueteria, usted, como usuario, nos confía su información. Mediante la presente política de privacidad (en adelante, la “Política”), informamos a nuestros usuarios cómo tratamos su información personal.
			</p>
			<p>
				Si nuestra página web ( www.pinocholibreriayjugueteria.com ) o nuestra Aplicación Pinocho libreria y jugueteria” para dispositivos móviles (en adelante, el “Portal”) contiene enlaces que conducen a la página web de otro proveedor, nuestra Política no se aplica a la página web a la que se le remite.
			</p>
			<p>
				Esta Política aplica a todos los usuarios de nuestro Portal y es necesario prestar su consentimiento expreso, libre e informado al momento de registrarse como usuario de Pinocho libreria y jugueteria. Por tanto, con su consentimiento a la siguiente Política, usted autoriza a Pinocho libreria y jugueteria y da su conformidad a la recopilación, procesamiento, uso y tratamiento de sus datos personales por nuestra parte, de conformidad con la normativa vigente en Argentina y en particular con la Ley 25.326 de Protección de Datos, así como cualquier norma que la reglamente, modifique o reemplace (en adelante, la “Normativa”).
			</p>
			<p>
				Los usuarios garantizan y responden, en cualquier caso, sobre la veracidad, exactitud, vigencia y autenticidad de la Información Personal facilitada, y se comprometen a mantenerla debidamente actualizada.
			</p>
			<p>
				Por favor, tómese el tiempo suficiente para leer esta Política detenidamente.
			</p>
			<p>
				Si usted tiene cualquier pregunta sobre esta Política o el tratamiento que le damos a sus datos personales, por favor escribanos un email a contacto@Pinocho libreria y jugueteria.com
			</p>
			<h4>
				1. PRINCIPIOS QUE ORIENTAN LA POLÍTICA
			</h4>
			<p>
				a. Principio de Legalidad: En el tratamiento de la información, se dará aplicación a las disposiciones vigentes y aplicables en la República Argentina, que rigen el tratamiento de la misma y demás derechos fundamentales conexos, incluyendo las disposiciones contractuales pactadas con los usuarios.
			</p>	
			<p>
				b. Principio de Libertad: El tratamiento de datos personales, sólo se llevará a cabo con el consentimiento, previo, expreso e informado del usuario. Los datos personales que no tengan el carácter de datos públicos, no podrán ser obtenidos o divulgados sin previa autorización, o en ausencia de mandato legal, estatutario, o judicial que releve el consentimiento.
			</p>
			<p>
				c. Principio de Finalidad: El tratamiento de la información que no tenga el carácter de dato público, a los que tenga acceso y sean recopilados y recogidos por Pinocho libreria y jugueteria, estarán subordinados y atenderán una finalidad legítima, la cual será informada al respectivo usuario de dicha información.
			</p>
			<p>
				d. Principio de Veracidad o Calidad: La información protegida sujeta a tratamiento debe ser veraz, completa, exacta, actualizada, comprobable y comprensible. Pinocho libreria y jugueteria no será responsable frente al Titular cuando sean objeto de tratamiento, datos o información parcial, incompleta o fraccionada o que induzca a error, entregada o divulgada por el Usuario declarando o garantizando, de cualquier forma, su veracidad o calidad. Pinocho libreria y jugueteria podrá -en caso que fuera posible- pero no está obligado, a verificar la veracidad o calidad de la información aportada por el Usuario, no constituyendo esta facultad una eximición al Usuario de su obligación de aportar información veraz, completa, exacta y actualizada. 
			</p>
			<p>
				e. Principio de Transparencia: En el tratamiento de información protegida, se garantizará el derecho del Usuario a obtener de Pinocho libreria y jugueteria, en cualquier momento y sin restricciones, información acerca de la existencia de cualquier tipo de información protegida que sea de su interés (legal, judicial o contractualmente justificado) y de su titularidad.
			</p>
			<p>
				f. Principio de Acceso y Circulación Restringida: La información protegida no estará disponible en Internet u otros medios de divulgación o comunicación masiva, salvo que el acceso sea técnicamente controlable para brindar un conocimiento restringido sólo a Pinocho libreria y jugueteria, las Sociedades Vinculadas, los usuarios o terceros debidamente autorizados. Para estos propósitos la obligación de Pinocho libreria y jugueteria, será de medio, según lo establece la normativa vigente.  
			</p>
			<p>
				g. Principio de Seguridad: La información protegida bajo la Política sujeta a tratamiento por Pinocho libreria y jugueteria, será objeto de protección en la medida en que los recursos técnicos y estándares mínimos así lo permitan, a través de la adopción de medidas tecnológicas de protección, protocolos, y medidas administrativas que sean necesarias para otorgar seguridad a los registros y repositorios electrónicos evitando su adulteración, modificación, pérdida, consulta, y en general en contra de cualquier uso o acceso no autorizado. En caso de que exista un riesgo particular de violación de la seguridad de la red, se informará a los usuarios sobre dicho riesgo y, si las medidas para atenuar o eliminar ese riesgo no están bajo su control, sobre las posibles soluciones.
			</p>
			<p>
				h. Principio de Confidencialidad: Todas y cada una de las personas que en Pinocho libreria y jugueteria administran, manejan, actualizan o tienen acceso a información protegida que no tenga el carácter de pública, y se encuentre en sistemas de información o bases o bancos de datos de terceros debidamente autorizados, se comprometen a conservar y mantener de manera estrictamente confidencial y no revelar a terceros, todas o cualesquiera de las informaciones personales, comerciales, contables, técnicas, comerciales o de cualquier otro tipo suministradas en la ejecución y ejercicio de sus funciones. Pinocho libreria y jugueteria y sus Sociedades Vinculadas para el tratamiento de la información protegida podrán utilizar los sistemas de información y bases de datos de propiedad de Pinocho libreria y jugueteria y/o de sus Sociedades Vinculadas.
			</p>
			<h4>
				2. RESPONSABLE DEL TRATAMIENTO
			</h4>
			<p>
				Informamos a nuestros usuarios que el responsable de la base de datos es Pinocho libreria y jugueteria S.A., CUIT 30-71198576-6, con domicilio en Mariscal Antonio José de Sucre 1530 Piso 6, Ciudad Autónoma de Buenos Aires, Argentina, y que los datos de carácter personal proporcionados a través del Portal, así como los que pudiera facilitar en el futuro en el marco de su relación con nosotros, son almacenados en nuestros servidores para ser conservados bajo seguridad de los mismos.

			</p>	
			<p>
				A continuación, informamos a nuestros usuarios qué datos recolectamos, para qué propósitos y bajo qué circunstancias los compartimos con otros.
			</p>
			<p>
				a. Datos personales que recolectamos cuando visita nuestro Portal
			</p>
			<p>
				Los datos personales son información con la que podemos relacionar a nuestros usuarios directa o indirectamente, tales como su nombre y apellidos, dirección, número de teléfono, fecha de nacimiento, datos de localización o dirección de correo electrónico y todo otro dato que usted nos provea.
			</p>	
			<p>
				A continuación, le mostramos qué datos recolectamos:
			</p>
			<p>
				<strong>
					Cuando usted visita nuestro Portal para realizar su próximo pedido, pero no se registra ni realiza un pedido, recopilamos los siguientes datos de navegación que no se encuentran relacionados con los datos personales de los visitantes:
				</strong>
			</p>
			<table>
				<tr>
					<th>CATEGORÍA DE INFORMACIÓN</th>
					<th>EXPLICACIÓN</th>
				</tr>
				<tr>
					<td>
						Información del dispositivo desde el que visita nuestro sitio web:
					</td>
					<td>
						Identificación del dispositivo, sistema operativo y/u otros identificadores del dispositivo, hardware.
					</td>
				</tr>
				<tr>
					<td>
						Información de conexión:
					</td>
					<td>
						Hora, fecha, duración de uso del sitio web y origen.
					</td>
				</tr>
			</table>
			<p>
				<strong>
					Si no sólo visita el Portal, sino que desea acceder a historial de pedidos (si ya fuera usuario) o si desea visualizar los servicios de Pinocho libreria y jugueteria, se le exige la registración como usuario para iniciar sesión. En tales supuestos se le solicita a aceptación expresa de esta Política y de los Términos y Condiciones generales de uso de Pinocho libreria y jugueteria, recopilamos los siguientes datos personales:
				</strong>
			</p>
			<table>
				<tr>
					<th>CATEGORÍA DE INFORMACIÓN</th>
					<th>EXPLICACIÓN</th>
				</tr>
				<tr>
					<td>
						Información de acceso:
					</td>
					<td>
						Nombre de usuario, contraseña
					</td>
				</tr>
				<tr>
					<td>
						Información de comunicación:
					</td>
					<td>
						Comentarios, puntuaciones y devoluciones, comunicaciones generales
					</td>
				</tr>
				<tr>
					<td>
						Otros datos:
					</td>
					<td>
						Datos o información que Ud. nos provea voluntariamente mientras utiliza el sitio web, aplicación u otras fuentes como redes sociales u otras bases de datos públicas.
					</td>
				</tr>
			</table>
			<p>
				<strong>
					Datos personales que recogemos al visitar nuestra página web, al registrarse y al realizar pedidos o utilizar los servicios de Pinocho libreria y jugueteria:
				</strong>
			</p>
			<table>
				<tr>
					<th>CATEGORÍA DE INFORMACIÓN</th>
					<th>EXPLICACIÓN</th>
				</tr>
				<tr>
					<td>
						Información de cuenta:
					</td>
					<td>
						Esta información puede incluir el nombre completo, domicilio, fecha de nacimiento, número telefónico, email, información de pago (incluida información de verificación de pago vinculada), documento de identidad o número de documentos de identificación ante organismos públicos, número de socio en programas de promociones asociados a Pinocho libreria y jugueteria, foto de perfil.
					</td>
				</tr>
				<tr>
					<td>
						Ubicación
					</td>
					<td>
						Si el usuario da permiso para procesar sus datos de ubicación recopilamos dicha información precisa o aproximada a través de datos como GPS, dirección IP y wifi. Esta información se recopila cuando Pinocho libreria y jugueteria funciona en primer plano y/o cuando está en segundo plano si el usuario dio permiso a dichos efectos en su dispositivo móvil o en los ajustes de Pinocho libreria y jugueteria.
					</td>
				</tr>
				<tr>
					<td>
						Información de acceso:
					</td>
					<td>
						Mail y contraseña.
					</td>
				</tr>
				<tr>
					<td>
						Información del dispositivo desde el que visita nuestro sitio web:
					</td>
					<td>
						Identificación del dispositivo, sistema operativo y/u otros identificadores del dispositivo, hardware.
					</td>
				</tr>
				<tr>
					<td>
						Información de conexión:
					</td>
					<td>
						Hora, fecha, duración de uso del sitio web y origen.
					</td>
				</tr>
				<tr>
					<td>
						Información de comunicación:
					</td>
					<td>
						Comentarios, puntuaciones y devoluciones Y comunicaciones generales.
					</td>
				</tr>
				<tr>
					<td>
						Historial de pedidos:
					</td>
					<td>
						Información sobre el tipo de servicio que solicita, el tipo de pedido que realiza, el detalle del pedido, la información de entrega, la fecha y hora en la que se realiza el pedido, el precio y la forma de pago.  
					</td>
				</tr>
				<tr>
					<td>
						Otra información:
					</td>
					<td>
						Información que el usuario nos provea voluntariamente mientras utiliza el sitio web o la aplicación e información de otras fuentes tales como redes sociales o aplicaciones que utilicen nuestra interfaz de conexión u otras bases de datos públicas.
					</td>
				</tr>
			</table>
			<p>
				En cualquiera de los casos antes indicados, por favor tenga presente que toda información que usted nos provea según lo antes descripto, Pinocho libreria y jugueteria la considera información personal suya y que Ud. declara que la información brindada se corresponde con sus datos personales y que los mismos son correctos y actualizados.
			</p>
			<p>
				b. Uso de los datos personales de los usuarios
			</p>
			<p>
				Solo recolectamos sus datos personales cuando es necesario y la finalidad es lícita y previamente definida. Pinocho libreria y jugueteria recopila y usa su información personal para los propósitos especificados en esta Política o en las secciones relevantes de nuestro Portal.
			</p>
			<p>
				Pinocho libreria y jugueteria utiliza su información para distintos fines:
			</p>	
			<table>
				<tr>
					<td>
						Prestación de servicios
					</td>
					<td>
						Utilizamos su información para ofrecer, personalizar, mantener y mejorar la prestación de los servicios que les ofrecemos a nuestros usuarios, así como realizar las siguientes actividades:
						<ul>
							<li>Administrar el sitio web.</li>
							<li>Crear y actualizar su cuenta.</li>
							<li>Verificar su perfil.</li>
							<li>Mejorar su experiencia de navegación personalizando el Portal.</li>
							<li>Habilitarlo a usted para el uso de los servicios disponibles en el Portal.</li>
							<li>Enviarle comunicados comerciales generales.</li>
							<li>Realizar comentarios y valoraciones de los comercios adheridos, su oferta y productos.</li>
							<li>Procesar y realizar el pago de los pedidos.</li>
							<li>Controlar la ruta del pedido para verificar su entrega.</li>
							<li>Activar funciones para personalizar su cuenta.</li>
						</ul>
					</td>
				</tr>
				<tr>
					<td>
						Servicio de Atención al Cliente
					</td>
					<td>
						Cuando el usuario se pone en contacto con nuestro Servicio de Atención al Cliente para obtener información o para presentar un reclamo, almacenamos la información que el usuario nos proporciona. A modo de ejemplo: la razón para contactarnos o en qué entrega faltaba algo. Dependiendo del motivo del contacto, los datos personales pueden variar. Como queremos mejorar nuestro servicio para usted, almacenamos la comunicación en su cuenta. De esta manera podemos responder a sus preguntas con mayor rapidez.
					</td>
				</tr>
				<tr>
					<td>
						Protección y seguridad:
					</td>
					<td>
						Utilizamos sus datos personales para mantener la protección, seguridad e integridad de nuestros servicios y usuarios. Asimismo, utilizamos la información para prevenir fraude.
					</td>
				</tr>
				<tr>
					<td>
						Investigación y desarrollo:
					</td>
					<td>
						Podemos utilizar la información que recopilamos para testear, investigar, analizar y desarrollar productos. Esto permite que podamos mejorar en términos de seguridad y que podamos desarrollar nuevas funciones o servicios.
					</td>
				</tr>
				<tr>
					<td>
						Publicidad
					</td>
					<td>
						Podemos enviarte correos electrónicos, SMS, push notifications o realizar llamadas a tu móvil, teléfono fijo o cualquier otro dispositivo que sea susceptible de recibir llamadas para ofrecerte vouchers, descuentos y promociones, realizar encuestas y/ o sondeos de opinión para mejorar nuestro servicio y la calidad del mismo. El usuario puede oponerse a recibir llamadas y al tratamiento posterior de los datos con fines publicitarios con cada correo electrónico o en los ajustes en el Portal.
					</td>
				</tr>
				<tr>
					<td>
						Marketing
					</td>
					<td>
						<p>
							Queremos evitar newsletters genéricas y medidas de marketing incontroladas. Por lo tanto, seleccionamos las ofertas que mejor se adapten a sus intereses y nos ponemos en contacto con usted si creemos que la información puede ser de su interés. Puede oponerse al tratamiento posterior de los datos con fines publicitarios con cada correo electrónico o en los ajustes en el Portal.
						</p>
						<p>
							Pinocho libreria y jugueteria podrá utilizar la información para promocionar y procesar concursos y sorteos, entregas de premios y ofrecerle publicidad y contenidos relacionados con nuestros servicios y los de nuestros socios comerciales o comercios adheridos.
						</p>
						<p>
							Asimismo, Pinocho libreria y jugueteria podrá enviarle muestras de productos.
						</p>
					</td>
				</tr>
				<tr>
					<td>
						Procedimientos judiciales o requerimientos administrativos
					</td>
					<td>
						Podremos utilizar su información personal en caso que nos sea requerido por orden judicial o resolución administrativa, regulatoria, arbitral, y en general cuando sea requerido por cualquier autoridad gubernamental.
					</td>
				</tr>
			</table>
			<p>
				El Usuario presta su pleno y total consentimiento para que Pinocho libreria y jugueteria recopile sus datos personales y los utilice, transfiera, almacene y ceda, de conformidad con el uso de información previsto en esta Política de Privacidad.
			</p>
			<p>
				3 ACTUALIZACIÓN DE LA INFORMACIÓN
			</p>
			<p>
				Si su información cambia o ha cambiado, es usted el responsable de modificarla en el Portal. Esto permitirá el correcto funcionamiento del sitio.
			</p>
			<h4>
				4. CON QUIÉN COMPARTIMOS SUS DATOS PERSONALES
			</h4>
			<p>
				En el evento que Pinocho libreria y jugueteria, en el ejercicio de sus actividades propias, utilice, transmita o transfiera internacionalmente datos personales garantizará el cumplimiento de los principios aplicables establecidos en la normativa aplicable.
			</p>
			<p>
				Concretamente Pinocho libreria y jugueteria, en el giro ordinario de sus negocios podrá incorporar la información que Ud. nos provea dentro de sus sistemas de información. Pinocho libreria y jugueteria, como responsable del tratamiento garantiza que los sistemas de información cumplen en su integridad la Política y la Normativa vigente en materia de protección de datos personales en Argentina.
			</p>
			<p>
				El usuario reconoce con la aceptación de la Política que, de presentarse una venta, fusión, consolidación, cambio de control societario, transferencia sustancial de activos, reorganización o liquidación de Pinocho libreria y jugueteria, Pinocho libreria y jugueteria podrá transferir, enajenar o asignar la Información Protegida a una o más partes relevantes, incluidas Sociedades Vinculadas.  
			</p>
			<p>
				En la siguiente sección le indicamos a quién le informamos sus datos y bajo qué condiciones, así como a qué países los transferimos.
			</p>
			<p>
				a. Qué terceros tienen acceso a los datos personales
			</p>
			<p>
				<strong>
					Empresas vinculadas a Pinocho libreria y jugueteria
				</strong>
			</p>
			<p>
				Podremos compartir datos con nuestras empresas vinculadas para facilitar y mejorar el procesamiento de nuestros datos sobre servicios. Por ejemplo, en la Unión Europea y Uruguay, Pinocho libreria y jugueteria procesa y almacena información en nombre de sus filiales internacionales.
			</p>
			<p>
				<strong>
					Comercios adheridos a Pinocho libreria y jugueteria
				</strong>
			</p>
			<p>
				Pinocho libreria y jugueteria comparte los datos estrictamente necesarios con los comercios adheridos a efectos de que los comercios adheridos puedan brindar el servicio contratado por parte de los usuarios.
			</p>
			<p>
				<strong>
					Proveedores de servicios y comercios adheridos a Pinocho libreria y jugueteria
				</strong>
			</p>
			<p>
				Pinocho libreria y jugueteria puede facilitar información a sus proveedores, consultores, socios de marketing, empresas de investigación y otros proveedores de servicios o socios comerciales. A modo de ejemplo Pinocho libreria y jugueteria podrá facilitar información a:
			</p>
			<ul>
				<li>Procesadores y facilitadores de pagos.</li>
				<li>Proveedores de almacenamiento en la nube.</li>
				<li>Socios de marketing y proveedores de plataformas de marketing.</li>
				<li>Proveedores de análisis de datos.</li>
				<li>Proveedores de investigación, incluidos los que implementan estudios o proyectos de investigación en colaboración con Pinocho libreria y jugueteria o en su nombre.</li>
				<li>Proveedores que ayudan a Pinocho libreria y jugueteria a mejorar la seguridad de sus apps.</li>
				<li>Consultores y otros proveedores de servicios profesionales.</li>
			</ul>
			<p>
				<strong>
					Otros
				</strong>
			</p>
			<p>
				Pinocho libreria y jugueteria puede compartir su información de otra manera que no sea la descripta en esta Política si así se lo notificamos y lo acepta expresamente.
			</p>
			<h4>
				5. A QUÉ PAÍSES TRANSFERIMOS SUS DATOS
			</h4>
			<p>
				Procesamos sus datos principalmente dentro de Argentina, Uruguay y dentro de la Unión Europea (UE). Sin embargo, algunos de nuestros proveedores de servicios tienen su sede en Estados Unidos y cumplen con los principios establecidos por la normativa aplicable para países con niveles no adecuados de legislación conforme la Ley 25.326.
			</p>
			<h4>
				6. SUS DERECHOS
			</h4>
			<p>
				Pinocho libreria y jugueteria es la responsable de la base de datos y ante quien podrán ejercerse los derechos previstos en la Ley 25.326 de Protección de Datos y aquellas normas que la modifiquen o reemplacen, acreditando debidamente su identidad o representación. De acuerdo con dicha normativa, usted podrá, previa acreditación de su identidad, solicitar, gratuitamente, el acceso, la rectificación, actualización inclusión o modificación, cancelación y cualquier otra acción relativa a su información personal de conformidad con Ley 25.326 de Protección de Datos.
			</p>
			<p>
				Pinocho libreria y jugueteria retiene la información del usuario y el perfil por el tiempo en que usted mantenga su cuenta en Pinocho libreria y jugueteria.
			</p>
			<p>
				Ud. tiene el derecho de acceder, dentro de los 10 (diez) días corridos desde la acreditación de su identidad, en forma gratuita a sus datos personales, en intervalos no inferiores a seis meses, salvo que se acredite un interés legítimo.
			</p>
			<p>
				Para la rectificación, actualización, eliminación, así como a la oposición del tratamiento de los datos personales, el titular de los mismo podrá ejercer tales derechos dentro de los 5 (cinco) días hábiles de acreditada su identidad. Pinocho libreria y jugueteria procederá con dicha solicitud o informará de las razones por las que estime no corresponde en el plazo anteriormente indicado.
			</p>
			<p>
				Puedes gestionar y solicitar la eliminación de tus datos personales tú mismo, desde las entradas “Mi Cuenta” y “Ayuda en línea” de la aplicación.
			</p>
			<p>
				La AGENCIA DE ACCESO A LA INFORMACIÓN PÚBLICA, en su carácter de Órgano de Control de la Ley N° 25.326, tiene la atribución de atender las denuncias y reclamos que interpongan quienes resulten afectados en sus derechos por incumplimiento de las normas vigentes en materia de protección de datos personales.
			</p>
			<p>
				Una vez finalizado el procedimiento de eliminación de sus datos personales, Pinocho libreria y jugueteria no tendrá registro alguno de sus datos personales en sus bases de datos, quedando únicamente los registros de pedidos realizados por usted a los solos efectos de análisis de prevención de fraude y estadísticos de la plataforma, sin ser asociados a ninguna cuenta.
			</p>
			<h4>
				7. INFORMACIÓN SOBRE COOKIES
			</h4>
			<p>
				Una cookie consiste en información enviada por un servidor web a un navegador web, y almacenada por el navegador. La información es luego enviada de nuevo al servidor en cada momento que el navegador solicita una página del servidor. Esto habilita al servidor a identificar y rastrear el navegador web. Nosotros usaremos tanto cookies de sesión como cookies persistentes únicamente en nuestro sitio web.
			</p>
			<p>
				Usaremos las cookies de sesión para estar al tanto de usted mientras utiliza el Portal.
			</p>
			<p>
				Por su parte, usaremos cookies persistentes para habilitar a nuestro sitio web que lo reconozca a usted cuando visita nuestro Portal. Las cookies de sesión serán eliminadas de su computadora cuando usted cierra el navegador web. Las cookies persistentes se mantendrán almacenadas en su computadora hasta que Ud las elimine, o hasta que lleguen a una fecha de expiración especificada.
			</p>
			<p>
				Utilizamos Google Analytics para analizar el uso de este sitio web. Google Analytics genera información estadística y de otro tipo sobre el uso de sitios web mediante cookies, las cuales son almacenadas en la computadora del usuario. La información generada en relación con nuestro sitio web es utilizada para crear reportes sobre el uso de nuestro sitio. Google almacenará esta información.
			</p>
			<p>
				Las políticas de privacidad de Google se encuentran disponibles en: http://www.google.com/privacypolicy.html
			</p>
			<p>
				La mayoría de los navegadores web lo autorizan a usted a rechazar la aceptación de cookies. Esto se logra a través de la configuración de cada navegador en particular. Esto sin embargo, tendrá un impacto negativo con respecto a la usabilidad de varios sitios web incluyendo este.
			</p>
			<h4>
				8. SEGURIDAD DE SU INFORMACIÓN PERSONAL Y SERVIDORES
			</h4>
			<p>
				Toda información recabada en el Portal será tratada en cumplimiento de la Normativa y los datos personales serán utilizados únicamente para los fines aquí consentidos o los que consienta oportunamente. Pinocho libreria y jugueteria expresa su compromiso de proteger la seguridad de la información personal de los usuarios. Con ese fin, Pinocho libreria y jugueteria usa una amplia variedad de tecnologías y procedimientos de seguridad para proteger la información personal contra un acceso, uso, modificación o una divulgación no autorizados. Sin perjuicio de esto, le recomendamos que no incluya información confidencial, secreta, comprometedora, datos sensibles o información personal delicada que usted no desea revelar en estas comunicaciones (incluyendo correos electrónicos). Asimismo, usted es responsable de proteger la confidencialidad de saus credenciales de acceso a la aplicación.
			</p>
			<p>
				Usted reconoce y acepta que, a pesar de todos nuestros esfuerzos, ninguna medida de seguridad de datos puede garantizar por completo la protección en todo momento.
			</p>
			<h4>
				9. CAMBIOS EN ESTA DECLARACIÓN DE PRIVACIDAD
			</h4>
			<p>
				Pinocho libreria y jugueteria se reserva el derecho de mantener actualizada esta Política de conformidad con la normativa vigente. Si se realizan cambios materiales en esta Política, se lo informaremos mediante una comunicación electrónica y de ser necesario se le solicitará nuevamente su consentimiento con la nueva Política que se implemente. Consulte con frecuencia esta declaración para estar informado, en forma permanente y actualizada, de cómo Pinocho libreria y jugueteria protege la privacidad de su información.
			</p>
			<h4>
				10. NOTA SOBRE EL USO DE ESTE SITIO POR PARTE DE NIÑOS
			</h4>
			<p>
				Este sitio no está dirigido a niños. No deseamos recopilar ninguna información que identifique personalmente a menores de edad (menor de 18 años). Si un menor de edad nos hubiera suministrado información que lo identifica personalmente, sus padres y/o tutores deberán comunicarse con nosotros a través del contacto indicado debajo. En caso de tomar conocimiento que los datos de un menor de edad han sido proporcionados a Pinocho libreria y jugueteria, eliminaremos dicha información a la mayor brevedad posible.
			</p>
			<h4>
				11. DISPOSICIONES FINALES
			</h4>
			<p>
				El Portal puede contener enlaces con referencias a otros sitios web más allá de nuestro control. Por favor recuerde que no tenemos ningún control sobre estos sitios web y que nuestra Política no es aplicable a estos sitios. Le recomendamos que lea las políticas de privacidad y los términos y condiciones de los sitios web conectados o referenciados en los que usted entra. Ninguna parte de esta Política supone la creación o adición de algún derecho o reclamo (ya sea legal, equitativo o de otro tipo) que cualquier individuo o persona pueda tener según la ley, o de alguna otra forma, en contra de la empresa, terceros, o sus directores respectivos, delegados, empleados, agentes o representantes; ni la existencia de la presente Política o su aplicación impondrá o agregará obligación alguna o responsabilidad a ninguno de los nombrados, que no tenga actualmente según la ley.
			</p>
			<h4>
				12. JURISDICCIÓN Y LEY APLICABLE
			</h4>
			<p>
				La presente Política se encuentra regida sin excepción y en todos sus términos por las leyes de la República de Argentina y será interpretada de acuerdo a ellas. Cualquier controversia derivada de la presente Política, su existencia, validez, interpretación, alcance o cumplimiento será sometida a los tribunales ordinarios de Justicia con jurisdicción en Argentina, renunciándose en forma expresa a cualquier otro fuero o jurisdicción.
			</p>
			<h4>
				13. CONSENTIMIENTO
			</h4>
			<p>
				Presto mi consentimiento para que mis datos personales, sean tratados en Argentina, y cedidos en caso de ser necesario para su procesamiento en la Unión Europea, Uruguay o Estados Unidos de conformidad con la legislación vigente en Argentina. Asimismo, presto mi consentimiento para que me hagan llegar vía correo electrónico u otro medio de comunicación, información sobre promociones y novedades relacionadas con Pinocho libreria y jugueteria, decisión que puedo revocar personalmente en todo momento a través de la configuración personal de mi cuenta.
			</p>
		</b-col>
	</b-row>
</template>
<script>
export default {
	metaInfo: {
    	titleTemplate: 'Terminos y condiciones',
    },
}
</script>
<style scoped lang="sass">
p, h4
	text-align: left
h4 
	font-size: 1em
	font-weight: 700
h1 
	margin-bottom: 1em
table 
	margin-bottom: 1em
td, th 
	padding: 1em
	border: 1px solid #000
	text-align: left
th 
	text-align: center
ul 
	text-align: left
</style>